<template>
  <span>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon color="orange" v-bind="attrs" v-on="on" class="btn-card">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t("btn.BusinessGroup") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
               <v-col cols="4" id="preview">
                  <img v-if="Src" :src="Src" style="width: 100%;" />
                </v-col>
              <v-row>
                <v-col cols="12">
                  <v-file-input show-size counter label="ภาพ ผู้บริหาร" required accept="image/png, image/jpeg, image/bmp" prepend-icon="mdi-camera" v-model="FileCover"></v-file-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="NameCEO" :rules="Rules" label="ชื่อ" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="Position" :rules="Rules" label="ตำแหน่ง" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="Catchphrase" :rules="Rules" label="คำโปรย" required></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false" :loading="$store.getters.overlay">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="SaveClick" :loading="$store.getters.overlay">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
      
    </v-dialog>


    <v-dialog v-model="dialogComplete" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          บันทึกข้อมูลเรียบร้อย
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="ClickComplete">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </span>
</template>
<script>
  export default {
    props: {
      Src:String,
      NameCEO:String,
      Position:String,
      Catchphrase:String,
      id: Number,
    },
    data: () => ({
      dialog: false,
      valid:false,
      dialogComplete:false,
      Rules: [
        v => !!v || 'File is required'
      ],
      req:{},
      FileCover:null,
    }),
    methods: {
      
      SaveClick() {
        if(this.$refs.form.validate()){
          this.$store.commit('set_overlay',true);
          let formData = new FormData();
          if(this.FileCover){
            formData.append('FileCover',this.FileCover,this.FileCover.name);
          }
          formData.append('NameCEO',this.NameCEO);
          formData.append('Position',this.Position);
          formData.append('Catchphrase',this.Catchphrase);
          formData.append('locale',this.$store.getters.authen.locale);
          formData.append('id',this.id);
          this.req.post(this.$store.getters.base_api + 'post-upload-ceo',formData,{ headers: {'Content-Type': 'multipart/form-data'},})
                .then(response=>{
                  this.dialog = false;
                  this.dialogComplete = true;
                  this.$store.commit('set_overlay',false);
               }).catch(error => {
                  this.$store.commit('set_overlay',true);
              });
        }
      },
      ClickComplete(){
        this.dialogComplete = false;
        this.$emit('complete');
      },
    },
    mounted() {
      this.req = this.$store.getters.req;
      
    },
  }
</script>